import { memo } from 'react';

function Icon() {
  const PRIMARY_MAIN = '#637381';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" fill="none" viewBox="0 0 44 44">
      <path
        fill={PRIMARY_MAIN}
        d="M4.182 36.039c.162 1.574 1.194 2.82 2.742 3.15 2.443.52 7.049 1.144 15.076 1.144 8.027 0 12.632-.624 15.076-1.145 1.547-.33 2.58-1.575 2.742-3.15.241-2.333.515-6.619.515-14.038 0-7.42-.274-11.705-.515-14.039-.162-1.574-1.195-2.82-2.742-3.15-2.444-.52-7.05-1.144-15.076-1.144-8.027 0-12.633.624-15.076 1.145-1.548.33-2.58 1.575-2.742 3.15C3.94 10.294 3.666 14.58 3.666 22c0 7.42.275 11.705.516 14.039z"
        opacity="0.32"
      />
      <path
        fill={PRIMARY_MAIN}
        d="M25.553 25.402a7.639 7.639 0 10-7.108 0c-3.252 1.24-5.736 4.131-6.506 7.695-.106.493.165 1 .662 1.09 1.783.322 4.735.646 9.4.646s7.617-.324 9.4-.647c.495-.09.765-.594.66-1.085-.769-3.566-3.253-6.459-6.508-7.699z"
      />
    </svg>
  );
}

export default memo(Icon);
